import { uniqByProp } from 'util/arrays'
import {
  UPDATE_TICKETS,
  CREATE_CHANGESET_SUCCESS,
  DELETE_TICKETS_STARTED,
  DELETE_TICKETS_SUCCESS,
} from 'constants/action_types'
import {
  FETCH_TICKETS_REQUEST,
  FETCH_TICKETS_RESPONSE,
  FETCH_TICKETS_ERROR,
  SET_ALL_TICKETS_VISIBILITY,
} from './types'

const defaultState = {}

export default function recentConversations(
  state = defaultState,
  { type, payload, data }
) {
  if (type === SET_ALL_TICKETS_VISIBILITY) {
    const { customerId, isVisible } = payload

    return {
      ...state,
      [customerId]: {
        ...state[customerId],
        showingAll: isVisible,
      },
    }
  }

  if (type === FETCH_TICKETS_REQUEST) {
    const { customerId, silent } = payload

    return {
      ...state,
      [customerId]: {
        ...state[customerId],
        tickets: (state[customerId] && state[customerId].tickets) || [],
        loading: !silent,
        reload: false,
      },
    }
  }

  if (type === FETCH_TICKETS_RESPONSE) {
    const { customerId, tickets, loadedAll } = payload

    return {
      ...state,
      [customerId]: {
        ...state[customerId],
        tickets: uniqByProp([...tickets, ...state[customerId].tickets], 'id'),
        loading: false,
        loadedAll,
      },
    }
  }

  if (type === FETCH_TICKETS_ERROR) {
    const { customerId } = payload

    return {
      ...state,
      [customerId]: {
        ...state[customerId],
        loading: false,
      },
    }
  }

  if (
    [
      UPDATE_TICKETS,
      CREATE_CHANGESET_SUCCESS,
      DELETE_TICKETS_STARTED,
      DELETE_TICKETS_SUCCESS,
    ].includes(type)
  ) {
    const tickets = data && (data.tickets || [data])
    const newState = { ...state }
    let changed = false

    tickets.forEach(ticket => {
      // NOTE (jscheel): We apparently store ids as integers in the recent conversations card
      const id = parseInt(ticket.id, 10)
      Object.keys(newState).forEach(customerId => {
        if (newState[customerId] && newState[customerId].tickets) {
          const customerTicketsIds = newState[customerId].tickets.map(t => t.id)
          if (customerTicketsIds.includes(id)) {
            changed = true
            newState[customerId] = {
              ...newState[customerId],
              reload: true,
            }
          }
        }
      })
    })

    if (changed) return newState
  }

  return state
}
